import { motion } from "framer-motion";

const CapitalDeMarca = () => {
  return (
    <section id="capital-de-marca" className="py-24 md:py-32 bg-muted">
      <div className="container px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto text-center"
        >
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold mb-10 tracking-tight">
             CAPITAL DE <span className="text-primary">MARCA®</span>
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-muted-foreground leading-relaxed">
            <p>Una marca no es solamente identidad, comunicación o reputación.</p>
            <p className="font-semibold text-foreground">
              Es un activo estratégico capaz de hacer perceptible el valor de una empresa.
            </p>
            <p>
              Cuando existe una brecha entre{" "}
              <span className="font-semibold text-foreground">lo que la empresa vale</span> y{" "}
              <span className="font-semibold text-foreground">lo que el mercado reconoce</span>, existe
              Capital de Marca® por construir.
            </p>
          </div>

          <p className="font-display text-2xl md:text-3xl text-primary mt-12">
            Nuestro trabajo es cerrar esa brecha.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default CapitalDeMarca;
